module.exports = __webpack_public_path__ + "static/media/a7.4ae64dd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dili/a7.mp3
// module id = r8Pw
// module chunks = 0